<template>
  <b-card-code title="لیست کاربران  ">


    <!--    <div class=" d-flex justify-content-start">-->
    <!--      <b-form-group>-->
    <!--        <div class="d-flex align-items-center">-->
    <!--          <b-button-->
    <!--              v-ripple.400="'rgba(255, 255, 255, 0.15)'"-->
    <!--              variant="success"-->
    <!--              :to="{ name: 'library-add'}"-->
    <!--          >-->
    <!--            ثبت کتاب جدید-->
    <!--          </b-button>-->
    <!--        </div>-->
    <!--      </b-form-group>-->
    <!--    </div>-->
    <!-- search input -->
    <div class="custom-search  justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">جستوجو</label>
          <b-form-input v-model="searchTerm" type="text" class="d-inline-block" @change="getUsers(currentPage)" />
        </div>
      </b-form-group>
    </div>

    <!--    <div class="custom-search  justify-content-end">-->
    <!--      <b-form-group-->
    <!--          label="انتخاب دسته محتوا (اجباری)"-->
    <!--          label-for="mother-categories"-->
    <!--      >-->
    <!--        <b-form-select-->
    <!--            id="mother-categories"-->
    <!--            v-model="categoryID"-->
    <!--            :options="categories"-->
    <!--            @change="getBooks(1)"-->

    <!--        />-->
    <!--      </b-form-group>-->
    <!--    </div>-->


    <!-- table -->
    <vue-good-table :columns="columns" :rows="rows" :rtl="direction" :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" :select-options="{
      enabled: false,
      selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
      selectionInfoClass: 'custom-class',
      selectionText: 'rows selected',
      clearSelectionText: 'clear',
      disableSelectInfo: true, // disable the select info panel on top
      selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    }" :pagination-options="{
      enabled: true,
      perPage: pageLength
    }">


      <template slot="table-row" slot-scope="props">

        <!-- Column: Name -->
        <span v-if="props.column.field === 'name'" class="text-nowrap">
          <b-avatar :src="props.row.avatar" class="mx-1" />
          <span class="text-nowrap">{{ props.row.firstName + ' ' + props.row.lastName }}</span>
        </span>

        <!--        &lt;!&ndash; Column: Status &ndash;&gt;-->
        <!--        <span v-else-if="props.column.field === 'status'">-->
        <!--          <b-badge :variant="statusVariant(props.row.status)">-->
        <!--            {{ props.row.status }}-->
        <!--          </b-badge>-->
        <!--        </span>-->

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>

            <!--             <b-button variant="warning"-->
            <!--                       :to="{ name: 'discount-edit', params: { id: props.row.id } }">-->
            <!--                  <feather-icon-->
            <!--                      icon="Edit2Icon"-->
            <!--                      class="mr-50"-->
            <!--                  />-->
            <!--                              <span>ویرایش</span>-->
            <!--              </b-button>-->

            <!--            <b-button variant="danger" class="ml-1" @click="deleteSubscription(props.row.id)">-->
            <!--                   <feather-icon-->
            <!--                       icon="TrashIcon"-->
            <!--                       class="mr-50"-->

            <!--                   />-->
            <!--                <span>حذف</span>-->
            <!--            </b-button>-->


          </span>
        </span>

        <span v-else-if="props.column.field === 'isAdmin'" class="text-nowrap">
          <b-form-checkbox v-model="props.row.isAdmin" checked="true" name="check-button" switch inline
            @change="editIsAdmin(props.row.isAdmin, props.row.id)">
            {{ props.row.isAdmin ? 'مدیر' : 'کاربر' }}
          </b-form-checkbox>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              نمایش {{ pageLength }} از
            </span>
            <b-form-select v-model="pageLength" :options="['30', '50', '70']" class="mx-1"
              @input="(value) => props.perPageChanged({ currentPerPage: value })" @change="getUsers(currentPage)" />
            <span class="text-nowrap"> از {{ totalRecords }} ورودی </span>
          </div>
          <div>
            <b-pagination :value="1" :total-rows="totalRecords" :per-page="pageLength" first-number last-number
              align="right" prev-class="prev-item" next-class="next-item" v-model="currentPage" class="mt-1 mb-0"
              @input="(value) => getUsers(currentPage)">
              <!--              <template #prev-text>-->
              <!--                <feather-icon-->
              <!--                    icon="ChevronLeftIcon"-->
              <!--                    size="18"-->
              <!--                />-->
              <!--              </template>-->
              <!--              <template #next-text>-->
              <!--                <feather-icon-->
              <!--                    icon="ChevronRightIcon"-->
              <!--                    size="18"-->
              <!--                />-->
              <!--              </template>-->
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BAvatar, BBadge, BPagination, BFormGroup, BButton, BFormInput, BFormSelect, BDropdown, BDropdownItem, BFormCheckbox
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import contentRepository from '@/modules/contents/services/contentRepository'
import { $themeConfig } from '@themeConfig'
import router from '@/router'
import Swal from 'sweetalert2'
import subscriptionRepository from '@/modules/subscriptions/services/subscriptionRepository'
import discountRepository from '@/modules/discount/services/discountRepository'
import libraryRepository from '@/modules/library/services/libraryRepository'
import { $appConfig } from '../../../../appConfig'
import categoryRepository from '@/modules/categories/services/categoryRepository'
import userRepository from '@/modules/users/services/userRepository'
import Dialog from 'vue-dialog-loading';

export default {
  name: 'listSubscriptions',
  components: {
    BCardCode,
    VueGoodTable,
    BAvatar,
    BBadge,
    BButton,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormCheckbox
  },
  data() {
    return {
      pageLength: 30,
      currentPage: 1,
      totalRecords: 0,
      pageCount: 0,
      categoryID: 0,
      categories: [],
      dir: false,
      columns: [
        {
          label: 'نام و نام خانوادگی ',
          field: 'name',
        },
        {
          label: 'شماره موبایل ',
          field: 'mobile',
        },

        {
          label: 'جنسیت ',
          field: 'gender',
        },
        {
          label: 'اشتراک فعال',
          field: 'enableSubscription',
        },
        {
          label: 'نوع اشتراک',
          field: 'subscriptionType',
        },
        {
          label: 'مدت زمان باقی مانده از اشتراک',
          field: 'timeOfEnableSubscription',
        },
        {
          label: 'نقش',
          field: 'isAdmin',
        },
      ],
      rows: [],
      searchTerm: '',
      status: [{
        1: 'Current',
        2: 'Professional',
        3: 'Rejected',
        4: 'Resigned',
        5: 'Applied',
      },
      {
        1: 'light-primary',
        2: 'light-success',
        3: 'light-danger',
        4: 'light-warning',
        5: 'light-info',
      }],
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  async created() {
    // await this.getCategories()
    // await this.getBooks(1)
    await this.getUsers(1)
  },
  methods: {
    async editIsAdmin(status, id) {
      let q = `/${id}/${status}`
      const { data } = await userRepository.editIsAdmin(q);
      if (data.isSuccess) {
        await this.getUsers(this.currentPage)
      } else {
        await Swal.fire('هشدار', data.message, 'warning');
      }
    },
    async getUsers(pageNo) {
      let query = {
        pageNo: pageNo,
        pageSize: Number(this.pageLength) ,
        // sortBy: "fullname | mobile | gender | active |type | remain ",
        // sortDir: 1 | 2,
        key: this.searchTerm
      }
      this.$loading.show({
        delay: 500,
        background: '#444'
      });

      const { data } = await userRepository.get(query)
      this.$loading.hide();

      if (data.isSuccess) {
        this.rows = data.data.users.map((p) => {

          let isEnabled;
          let type;
          let daysLeft;
          if (p.licenses?.length > 0) {

            for (const licens of p.licenses) {

              const ticksToDate = require('ticks-to-date');
              const date = ticksToDate(licens?.buyAt);
              let Difference_In_Time = new Date().getTime() - new Date(date.toUTCString()).getTime();

              var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

              if (Difference_In_Days < licens?.subscription?.expireMonths * 30) {
                isEnabled = true;
                daysLeft = licens?.subscription?.expireMonths * 30 - Difference_In_Days;
                type = licens?.subscription?.title;
              }

            }

          }

          return {
            id: p.id,
            firstName: p.firstName === null || typeof p.firstName === 'undefined' ? '-' : p.firstName,
            lastName: p.lastName === null || typeof p.lastName === 'undefined' ? '-' : p.lastName,
            fullName: p.fullName,
            mobile: p.mobile,
            education: p.education,
            nationalID: p.nationalID,
            birthDate: p.birthDate,
            isAdmin: p.isAdmin,
            gender: p.gender === 1 ? 'مرد' : p.gender === 2 ? 'زن' : '-',
            licenses: p.licenses,
            enableSubscription: isEnabled ? 'دارد' : 'ندارد',
            subscriptionType: type,
            // timeOfEnableSubscription: p.licenses?.length > 0 ? p.licenses[0]?.subscription?.expireMonths * 30 - Difference_In_Days : '-',
            timeOfEnableSubscription: daysLeft ? parseInt(daysLeft) : '-',
            avatar: $appConfig.endpoint.baseFileDomain + '/' + p.avatar,
          }
        })
        this.totalRecords = data.data.totalRecordCount
      }
    },

  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
